module.exports = vendor2_f8e89d91;